module.exports = __webpack_public_path__ + "static/media/about.aa82b327.mp4";